import { Button } from "@/lib/components/Button/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/lib/components/Dialog";

type PushInWarningDialogProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onContinue: () => void;
  isLoading: boolean;
};

export function PushInWarningDialog({
  isOpen,
  onOpenChange,
  onContinue,
  isLoading,
}: PushInWarningDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader className="w-full">
          <DialogTitle className="mb-2 pr-2">
            Continue without changing animations?
          </DialogTitle>
          <DialogDescription>
            For the best results,{" "}
            <span className="font-semibold">
              mix at least three animation styles{" "}
            </span>
            in a video. It makes a big difference in the final look.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={onContinue} disabled={isLoading}>
            {isLoading ? "Animating..." : "Animate images"}
          </Button>
          <DialogClose asChild>
            <Button type="button" variant="outline" disabled={isLoading}>
              Cancel
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
